import { render, staticRenderFns } from "./SliderV10.vue?vue&type=template&id=08f5c454&"
import script from "./SliderV10.vue?vue&type=script&lang=js&"
export * from "./SliderV10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports